module.exports = __webpack_public_path__ + "static/media/logo-acorn.b8e350d1.png";